import React, { useState } from 'react';
import {
	Box,
	List,
	ListItem,
	ListItemText,
	Modal,
	IconButton,
	Paper,
	Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { localDateFormat } from '../../helpers/hours';
import { Link } from 'react-router-dom';

export const EventModal = ({ eventData, openModal, handleCloseModal }) => {
	// Order event's
	const events = Object.entries(eventData?.extendedProps?.bias?.areas || []);

	// Is order delayed?
	const isDelayed = eventData?.extendedProps?.bias?.status === 'DLY';

	// Order id
	const orderID = eventData?.extendedProps?.bias?.order_id;

	// Path to order
	const pathToOrder = `/dashboard/order/${orderID}`;

	// Modal style config
	const modalStyle = {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		width: 400,
		height: `${events?.length <= 4 ? '40' : '80'}%`,
		bgcolor: 'background.paper',
		border: '2px solid #000',
		boxShadow: 24,
		p: 4,
		overflowY: 'scroll',
	};

	const handleDeepLinkToOrder = () => {
		// Set order path temporarily
		localStorage.setItem('lastPathPilu', pathToOrder);
		setTimeout(() => {
			// Set current path
			const currentPath = '/dashboard/plan-de-produccion';
			// Reset current path
			localStorage.setItem('lastPathPilu', currentPath);
		}, 2000);
	};

	return (
		<Modal
			open={openModal}
			onClose={handleCloseModal}
			aria-labelledby='modal-title'
			aria-describedby='modal-description'
		>
			<Box sx={modalStyle}>
				<IconButton
					style={{ position: 'absolute', top: '8px', right: '8px' }}
					onClick={handleCloseModal}
				>
					<CloseIcon />
				</IconButton>
				{eventData && (
					<>
						<Typography variant='h6' id='modal-title' gutterBottom>
							<Link
								to={pathToOrder}
								target='_blank'
								onClick={handleDeepLinkToOrder}
							>
								{eventData.title}
							</Link>
							{isDelayed && (
								<span
									style={{
										color: '#F44336',
									}}
								>
									{' '}
									- Retraso
								</span>
							)}
						</Typography>
						<Typography variant='body1' id='modal-description'>
							{localDateFormat(eventData.startStr)}
						</Typography>
						<Box>
							<Typography variant='h6' gutterBottom mt={2}>
								Áreas:
							</Typography>
							<Paper elevation={3}>
								<List>
									{events.map(([areaName, objArea]) => (
										<ListItem key={areaName}>
											<ListItemText
												primary={
													<>
														{eventData.extendedProps
															.currentArea ===
														areaName ? (
															<b>
																<u>
																	{
																		objArea.name
																	}
																</u>
															</b>
														) : (
															objArea.name
														)}
													</>
												}
												secondary={`Días: ${
													objArea.days
												} - Fecha: ${localDateFormat(
													objArea?.date
												)}`}
											/>
										</ListItem>
									))}
								</List>
							</Paper>
						</Box>
					</>
				)}
			</Box>
		</Modal>
	);
};
